(() => {
  if (window.__wrpgCartUpsellBound) return;
  window.__wrpgCartUpsellBound = true;

  function roots() {
    const page = document.getElementById("wrpg-cart-upsell");
    if (page) return [page];
    return [...document.querySelectorAll("cart-drawer .wrpg-cart-upsell")];
  }

  function extractCard(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const wrap = doc.querySelector(".wrpg-standard-product-card");
    if (!wrap) return "";
    wrap.querySelectorAll("script, link").forEach((node) => node.remove());
    return wrap.outerHTML;
  }

  function paintInjectedCard() {
    if (typeof window.wrpgPaintProductCards === "function") {
      window.wrpgPaintProductCards();
      return;
    }
    if (window.wrpgWishlist && typeof window.wrpgWishlist.sync === "function") {
      window.wrpgWishlist.sync();
    }
    if (window.wrpgOwnership && typeof window.wrpgOwnership.sync === "function") {
      window.wrpgOwnership.sync();
    }
  }

  function headingForCount(root, count) {
    if (count > 1 && root.dataset.headingPlural) return root.dataset.headingPlural;
    return root.dataset.heading || "";
  }

  function loadUpsell() {
    const mounts = roots();
    if (mounts.length === 0) return Promise.resolve();

    const first = mounts[0];
    const endpoint = first.dataset.endpoint || "/apps/wrpg/cart-upsell";

    return fetch("/cart.js", { cache: "no-store" })
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((cart) => {
        const ids = (cart.items || []).map((item) => String(item.product_id)).filter(Boolean);
        if (ids.length === 0) {
          mounts.forEach((root) => {
            root.hidden = true;
            root.innerHTML = "";
          });
          return null;
        }
        const heading = headingForCount(first, ids.length);
        const url = `${endpoint}${endpoint.includes("?") ? "&" : "?"}product_ids=${encodeURIComponent(ids.join(","))}&t=${Date.now()}`;
        return fetch(url, { cache: "no-store" }).then((response) =>
          response.ok ? response.json().then((data) => ({ data, heading })) : Promise.reject(),
        );
      })
      .then((payload) => {
        if (!payload || !payload.data || !payload.data.upsell || !payload.data.upsell.handle) {
          mounts.forEach((root) => {
            root.hidden = true;
            root.innerHTML = "";
          });
          return null;
        }
        const handle = encodeURIComponent(payload.data.upsell.handle);
        return fetch(`/products/${handle}?view=wrpg-card`, { cache: "no-store" }).then((response) =>
          response.ok ? response.text().then((html) => ({ html, heading: payload.heading })) : Promise.reject(),
        );
      })
      .then((payload) => {
        if (!payload) return;
        const card = extractCard(payload.html);
        if (!card) return;
        const kicker = payload.heading
          ? `<p class="wrpg-cart-upsell__kicker">${payload.heading}</p>`
          : "";
        mounts.forEach((root) => {
          root.hidden = false;
          root.innerHTML = kicker + card;
        });
        paintInjectedCard();
        if (typeof window.__wrpgEqualizeDealGrids === "function") {
          window.__wrpgEqualizeDealGrids();
        }
      })
      .catch(() => {
        roots().forEach((root) => {
          root.hidden = true;
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadUpsell, { once: true });
  } else {
    loadUpsell();
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      window.setTimeout(loadUpsell, 80);
    });
  }
})();
